import { logOut } from '@/store/slices/authSlice.ts'
import { store } from '@/store/store.ts'
import { navigateTo } from '@/utils/globalNavigation.tsx'
import axios from 'axios'
import { stringify } from 'qs'

const apiClient = axios.create({
    baseURL: import.meta.env.VITE_BASE_URL,
    // withCredentials: true,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    },
    paramsSerializer: (params) =>
        stringify(params, {
            arrayFormat: 'brackets',
            encodeValuesOnly: true
        })
})

apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response.status === 401) {
            store.dispatch(logOut())
            navigateTo('/login', { replace: true })
        }
        return Promise.reject(error)
    }
)
export default apiClient
